import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { RidersFilters } from '../../../commons/models/riders';

@Component({
  selector: 'app-riders-filters',
  templateUrl: './riders-filters.component.html',
  styleUrls: ['./riders-filters.component.scss']
})
export class RidersFiltersComponent{
    @Output()
    onFilter: EventEmitter<RidersFilters> = new EventEmitter();

    private _defaultFilters: RidersFilters;
    filtersForm: FormGroup;

    constructor(private fb: FormBuilder) {
        this._createForm();
    }

    private _createForm() {
    let group = {
        filter: "",
        onlyCurrentTenant: [true]
    }

    this.filtersForm = this.fb.group(group);
    }

    applyFilters() {
        this.onFilter.emit(this._getFilters());
    }

    private _getFilters(): RidersFilters {
        let filters: RidersFilters = {}
        if (this.filtersForm) {
            const values = this.filtersForm.value;
            filters.filter = values.filter;
            filters.onlyCurrentTenant = values.onlyCurrentTenant;
        }
        return filters;
    }

    resetFilters() {
        this.filtersForm.reset();
        this.filtersForm.patchValue({
          filter: "",
          onlyCurrentTenant: true
        });
        this._setDefaultValues();
        this.applyFilters();
    }
    
    get defaultFilters(): RidersFilters {
    return this._defaultFilters;
    }

    @Input()
    set defaultFilters(defaultFilters: RidersFilters) {
        this._defaultFilters = defaultFilters;
        this._setDefaultValues();
    }

    private _setDefaultValues() {
    if (this.defaultFilters) {
        if (this.filtersForm) {
        this.filtersForm.patchValue({
            filter: this.defaultFilters.filter,
            onlyCurrentTenant: this.defaultFilters.onlyCurrentTenant
        })
        }
    }
    }



}